import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import './styles.css';
import QuickreplyIcon from '@mui/icons-material/Quickreply';
import { AuthContext } from '../../context/Auth/AuthContext';
import useQuickMessages from '../../hooks/useQuickMessages';
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { IconButton, MenuItem, Popper, Paper, MenuList, ClickAwayListener } from '@material-ui/core';

export const Submenus = (props) => {

  const { setInputMessage, setMediaUrl, setMediaName, sendMessageQuick } = props;

  const { user } = useContext(AuthContext);

  const { list2: listQuickMessages } = useQuickMessages();

  const [listCategories, setListCategories] = useState([]);

  useEffect(() => {

    getListMessages();

  }, []);
  const getListMessages = async () => {
    try {
        const companyId = localStorage.getItem("companyId");
        const messages = await listQuickMessages({ companyId, userId: user.id });

        // Agrupamos as mensagens por categoria se necessário
        // ou usamos diretamente se já vêm agrupadas
        setListCategories(messages || []);
    } catch (e) {
        console.error("Erro ao carregar mensagens rápidas:", e);
        setListCategories([]);
    }
};


  const limitCaracteres = (message) => {
    if (message.length > 30) {
      return message.substring(0, 30) + '...';
    } else {
      return message;
    }
  }
  // Estado para submenu baseado em hover
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
  const [submenuCategory, setSubmenuCategory] = useState(null);
  const closeTimerRef = useRef(null);
  const openTimerRef = useRef(null);

  const handleCategoryEnter = useCallback((category, anchorEl) => {
    // Cancela fechamento
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    // Abre imediatamente (sem debounce) para sensação mais responsiva
    const sameCategory = submenuCategory && submenuCategory.id === category.id;
    const sameAnchor = submenuAnchorEl === anchorEl;
    if (!sameCategory || !sameAnchor) {
      setSubmenuCategory(category);
      setSubmenuAnchorEl(anchorEl);
    }
    if (!submenuOpen) setSubmenuOpen(true);
  }, [submenuCategory, submenuAnchorEl, submenuOpen]);

  const scheduleSubmenuClose = () => {
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    if (openTimerRef.current) {
      clearTimeout(openTimerRef.current);
      openTimerRef.current = null;
    }
    closeTimerRef.current = setTimeout(() => {
      setSubmenuOpen(false);
      setSubmenuAnchorEl(null);
      setSubmenuCategory(null);
    }, 350);
  };

  const [mainOpen, setMainOpen] = useState(false);
  const [mainAnchorEl, setMainAnchorEl] = useState(null);

  const handleMainButtonClick = (e) => {
    const anchor = e.currentTarget;
    setMainAnchorEl(anchor);
    setMainOpen((prev) => !prev);
  };

  const closeAllMenus = useCallback(() => {
    setMainOpen(false);
    setMainAnchorEl(null);
    setSubmenuOpen(false);
    setSubmenuAnchorEl(null);
    setSubmenuCategory(null);
  }, []);

  return (
    <ClickAwayListener onClickAway={closeAllMenus}>
      <div style={{ display: 'inline-block' }}>
        <IconButton
          size="small"
          color="default"
          style={{ padding: 4 }}
          onClick={handleMainButtonClick}
        >
          <QuickreplyIcon style={{ color: 'grey' }} />
        </IconButton>

        {/* Menu principal com Popper para reduzir overhead */}
        <Popper
          open={mainOpen}
          anchorEl={mainAnchorEl}
          placement="bottom-start"
          disablePortal={false}
          style={{ zIndex: 2000 }}
          modifiers={{
            offset: { enabled: true, offset: '0,6' },
            preventOverflow: { enabled: true, boundariesElement: 'window' }
          }}
        >
          <Paper
            style={{ fontSize: 12, maxHeight: 300, overflowY: 'auto' }}
            onMouseEnter={() => {
              if (closeTimerRef.current) {
                clearTimeout(closeTimerRef.current);
                closeTimerRef.current = null;
              }
            }}
            onMouseLeave={scheduleSubmenuClose}
            elevation={4}
          >
            <MenuList dense disablePadding>
              {listCategories && listCategories.length > 0 ? (
                listCategories.map((category) => (
                  <MenuItem
                    key={category.id}
                    onMouseEnter={(e) => handleCategoryEnter(category, e.currentTarget)}
                    selected={submenuCategory && submenuCategory.id === category.id}
                  >
                    {category.shortcode}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>
                  Nenhuma categoria disponível, cadastre categorias no menu "Respostas ràpidas".
                </MenuItem>
              )}
            </MenuList>
          </Paper>
        </Popper>

          {/* Submenu flutuante, agora com Popper + Paper (mais leve que Menu) */}
          <Popper
            open={submenuOpen}
            anchorEl={submenuAnchorEl}
            placement="right-start"
            disablePortal={false}
            style={{ zIndex: 2000 }}
            modifiers={{
              offset: { enabled: true, offset: '8,0' },
              flip: { enabled: false },
              preventOverflow: { enabled: true, boundariesElement: 'window' }
            }}
          >
            <Paper
              style={{ maxHeight: 180, overflowY: 'auto' }}
              onMouseEnter={() => {
                if (closeTimerRef.current) {
                  clearTimeout(closeTimerRef.current);
                  closeTimerRef.current = null;
                }
              }}
              onMouseLeave={scheduleSubmenuClose}
              elevation={4}
            >
              <MenuList dense disablePadding>
                {submenuCategory ? (
                  submenuCategory.messages && submenuCategory.messages.length > 0 ? (
                    submenuCategory.messages.map((message) => (
                      <MenuItem
                        key={message.id}
                        title={message.message}
                        onClick={() => {
                          try { sendMessageQuick(message); } finally {
                            closeAllMenus();
                          }
                        }}
                      >
                        {message.mediaPath ? <AttachFileIcon style={{ fontSize: 15, marginRight: 6 }} /> : null}
                        {limitCaracteres(message.shortcode)}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>
                      Nenhuma mensagem disponível, cadastre mensagens no menu "Respostas ràpidas".
                    </MenuItem>
                  )
                ) : null}
              </MenuList>
            </Paper>
          </Popper>
      </div>
    </ClickAwayListener>
  );
}
